import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import type { PatPermission } from "@common/schemas/domains/personalAccessToken/personal-access-token.schema";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { McpCliTokenRow } from "../mcpCliTokensViewConfig";
import { formatPermissions } from "../mcpCliTokenHelpers";

export const TokenPermissionsCell = memo(
    ({
        getValue,
    }: CellContext<ViewTableFeatures, McpCliTokenRow, PatPermission[]>) => (
        <ViewTableCell>{formatPermissions(getValue())}</ViewTableCell>
    ),
);
